import keyMirror from "key-mirror";
import { Map } from "immutable";

export const CASE_ACTIONS = keyMirror({
    RENEW: null,
    ENHANCE: null,
    VIEW_CASE: null
});

export const CASE_CATEGORY_TYPES = new Map({
    "New": 1,
    "Enhancement": 2,
    "Re-Open": 3
});